import React from 'react';
import styled from 'styled-components';
import Heading from './Heading';
import ContactCarousel, { ContactCarouselItem } from './ContactCarousel';
import WidthWrapper from './WidthWrapper';
import useWindowSize from '../hooks/useWindowSize';
import { useStaticQuery, graphql } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';

const StyledContactForm = styled.div`
  display: flex;
  flex-direction: column;

  .brow {
    color: var(--primary);
  }

  .width-wrapper {
    display: flex;
    width: 100%;
    gap: 2rem;
    padding: 0 0 0 2rem;
    justify-content: space-between;
    align-items: center;
  }

  .carousel-section {
    width: 100%;
    height: fit-content;

    .carousel-image {
      height: 49.875rem;
      width: 100%;
    }
  }

  .contact-form {
    border: none;
  }

  @media (max-width: 800px) {
    .carousel-section {
      width: 100%;

      .carousel-image {
        height: 35rem;
      }
    }

    iframe {
      padding: 2rem 1rem 0 1rem;
    }

    .width-wrapper {
      flex-direction: column;
      justify-content: flex-start;
      padding: 0;
      gap: 0;
    }
  }
`;

const ContactForm = ({ contact }) => {
  const data = useStaticQuery(graphql`
    query ContactCarouselQuery {
      prismicContactCarousel {
        data {
          carousel_items {
            image {
              alt
              url
              gatsbyImageData(placeholder: BLURRED, width: 800, height: 800)
            }
          }
          description
          heading
        }
      }
    }
  `);

  const carouselSlides = data.prismicContactCarousel.data;

  const size = useWindowSize();
  let formHeight;
  if (size.width > 800) {
    formHeight = 650;
  } else if (size.width > 400) {
    formHeight = 700;
  } else {
    formHeight = 725;
  }

  return (
    <StyledContactForm>
      <Heading
        neutral100
        headingText="Ready to change the way your hospitality brand does social?"
        description="For general information on BCV's comprehensive social media solution, fill out our contact form below. Our specialists will reach out to you within 24 hours. "
        widthWrapper
        browText={contact && 'Contact us'}
      />

      <WidthWrapper>
        <iframe
          src="https://ww2.rategain.com/l/413792/2023-04-12/23m957g"
          title="Contact Form"
          width="100%"
          height={formHeight}
          type="text/html"
          allowtransparency="true"
          className="contact-form"
        ></iframe>
        {/* <div className="carousel-section">
          <ContactCarousel>
            {carouselSlides.carousel_items.map((slide, idx) => {
              const image = getImage(slide.image.gatsbyImageData);
              return (
                <ContactCarouselItem
                  src={image}
                  alt={slide.image?.alt ? slide.image?.alt : 'Carousel Image'}
                  heading={carouselSlides.heading}
                  description={carouselSlides.description}
                  key={idx}
                />
              );
            })}
          </ContactCarousel>
        </div> */}
      </WidthWrapper>
    </StyledContactForm>
  );
};

export default ContactForm;
